import axios from "axios";

// En Docker/producción, se recomienda usar una ruta relativa (/api) y que Nginx haga proxy.
// En desarrollo local, podés apuntar a http://localhost:5002.
const PRIMARY_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";

// Fallbacks opcionales (mantengo localhost por comodidad). Si querés mantener las IPs históricas,
// se pueden agregar vía REACT_APP_API_FALLBACKS (CSV).
const FALLBACKS = (process.env.REACT_APP_API_FALLBACKS || "")
  .split(",")
  .map((s) => s.trim())
  .filter(Boolean);

const BASE_URLS = [PRIMARY_BASE_URL, ...FALLBACKS.filter((u) => u !== PRIMARY_BASE_URL)];

const createClient = (baseURL) => {
  const client = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
    },
  });

  client.interceptors.request.use((config) => {
    const token = localStorage.getItem("sapToken");
    const user = JSON.parse(localStorage.getItem("sapUser"));

    if (user && user.ExpiresAt) {
      const expiresAt = new Date(user.ExpiresAt);
      const now = new Date();

      if (now >= expiresAt) {
        console.warn("⏰ Sesión de SAP expirada. Cerrando sesión y redirigiendo...");
        localStorage.removeItem("sapToken");
        localStorage.removeItem("sapUser");
        window.location.href = "/login";
        return Promise.reject("Sesión expirada");
      }
    }

    if (token) {
      config.headers["Authorization"] = token;
    }

    return config;
  });

  return client;
};

const apiClient = {};

// Métodos tradicionales: get, post, put, patch, delete
["get", "post", "put", "patch", "delete"].forEach((method) => {
  apiClient[method] = async (url, dataOrConfig = {}, config = {}) => {
    let lastError;

    // Si es GET o DELETE, el segundo parámetro es `config`
    const isBodyless = method === "get" || method === "delete";

    for (const baseURL of BASE_URLS) {
      const client = createClient(baseURL);
      try {
        const response = await client.request({
          method,
          url,
          ...(isBodyless ? { ...dataOrConfig } : { data: dataOrConfig, ...config }),
        });
        return response;
      } catch (error) {
        lastError = error;
        console.warn(`❌ Error al intentar ${method.toUpperCase()} ${baseURL}${url}:`, error.message);
      }
    }

    throw lastError;
  };
});

export default apiClient;
